import { Injectable } from '@angular/core';
import Config from 'models/config/config.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: Config = new Config();

  constructor(private http: HttpClient) { }

  public async readConfig(): Promise<boolean> {
    return new Promise((resolve: (r: boolean) => any, reject: (e: Error) => any) => {
      this.http.get<any>('assets/conf.json').subscribe({
        next: data => {
          this.config = new Config(data);
          return resolve(true);
        },
        error: error => console.error('There was an error!', error)
      });
    });
  }

  getConfig() {
    return this.config;
  }
}
